import { Component } from "@angular/core";

@Component({
  selector: "app-tutor-dashboard-absent",
  templateUrl: "./tutor-dashboard-absent.component.html",
})
export class TutorDashboardAbsentComponent {
  selected = "first";
}
